module.exports = __webpack_public_path__ + "static/media/herders_legend.c93029b4.png";